import React, { useState, useCallback, useEffect } from 'react';
import { Modal } from 'antd';
import { withTranslation } from 'react-i18next';
import { MAIL_TEMPLATE_MODAL } from './translationValues';
import CreateComplexEmailTemplate from './CreateComplexMailTemplate';
import DocumentFlowsTemplate from './DocumentFlowsTemplate';
import { COMPLEX_DOCUMENT_CONTEXT_KEYS, useDocumentContext } from '../../context/complexDocumentContext';

const CreateMailTemplateModal = props => {
  const { visible, onCancel, onSucess, type, template = {}, t, isDocToEmail= false,
    categoryId = undefined, resourceGroupId = undefined, communicationId = undefined } = props;
  const [showFlows, setShowFlows] = useState(false);

  const toggleFlowView = useCallback((checked) => {
    setShowFlows(checked);
  }, []);

  const customSelector = useCallback((store) => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.FLOWS], []);
  const [flows, store] = useDocumentContext(customSelector, 'ComplexArtboard');

  useEffect(() => {
    return () => {
      store.set({[COMPLEX_DOCUMENT_CONTEXT_KEYS.SELECTED_FLOWS]: [] });
    };
  }, [])

  return (
    <Modal
      centered
      title={ `${type === 'cloneTemplate' ? t(MAIL_TEMPLATE_MODAL.CLONE_TEMPLATE_TITLE.key, MAIL_TEMPLATE_MODAL.CLONE_TEMPLATE_TITLE.value) : t(MAIL_TEMPLATE_MODAL.CREATE_NEW_EMAIL_TEMPLATE_TITLE.key, MAIL_TEMPLATE_MODAL.CREATE_NEW_EMAIL_TEMPLATE_TITLE.value)}`}
      maskClosable={false}
      visible={visible}
      width="625px"
      footer={false}
      onCancel={onCancel}
      className="warning-modal"
    >
      <CreateComplexEmailTemplate
        mailModal={true}
        type={type}
        onSucess={onSucess}
        template={template}
        selectDesign={false}
        isDocToEmail={isDocToEmail}
        selectFlows={toggleFlowView}
        showFlows={showFlows}
        categoryId={categoryId}
        resourceGroupId={resourceGroupId}
        communicationId={communicationId}
      />
     {showFlows && flows && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: '100%',
            background: 'rgb(37,41 ,45)',
            width: '268px',
            height: '100%',
            borderRadius: '4px 4px 8px 8px',
            overflow: 'auto',
            padding: '0px 0px 0px 2px'
          }}
        >
          <DocumentFlowsTemplate flows={flows} />
        </div>
      )}
    </Modal>
  );
};

export default withTranslation(["MAIL_TEMPLATE_MODAL"])(CreateMailTemplateModal);
